import { FormattedMessage } from 'react-intl'
import Chip from '@mui/material/Chip'

function ProjectPendingChangesChip({ project }) {
  if (!project?.pendingChanges) return null

  return (
    <Chip
      label={<FormattedMessage id="dashboard.projects.pendingChanges" />}
      size="small"
      sx={{
        bgcolor: 'pendingChanges.main',
        color: 'pendingChanges.contrastText',
      }}
    />
  )
}

export default ProjectPendingChangesChip
